import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { type ReactNode } from "react";

function TooltipProvider({ children }: { children: ReactNode }) {
  return <BaseTooltip.Provider delay={600}>{children}</BaseTooltip.Provider>;
}

function TooltipRoot({ children }: { children: ReactNode }) {
  return <BaseTooltip.Root>{children}</BaseTooltip.Root>;
}

function TooltipTrigger({
  className,
  render,
  children,
}: {
  className?: string;
  render?: React.ComponentProps<typeof BaseTooltip.Trigger>["render"];
  children: ReactNode;
}) {
  return (
    <BaseTooltip.Trigger className={className} render={render}>
      {children}
    </BaseTooltip.Trigger>
  );
}

function ArrowSvg(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="10"
      viewBox="0 0 20 10"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
        className="fill-fg"
      />
    </svg>
  );
}

function TooltipContent({ children }: { children: ReactNode }) {
  if (!children) return null;

  return (
    <BaseTooltip.Portal>
      <BaseTooltip.Positioner sideOffset={6}>
        <BaseTooltip.Popup className="z-50 max-w-80 origin-(--transform-origin) rounded-lg bg-fg px-3 py-1.5 text-bg text-sm shadow-lg transition-[transform,scale,opacity] data-ending-style:scale-95 data-starting-style:scale-95 data-ending-style:opacity-0 data-starting-style:opacity-0 data-instant:transition-none">
          <BaseTooltip.Arrow className="data-[side=bottom]:-top-2 data-[side=left]:-right-3.25 data-[side=top]:-bottom-2 data-[side=right]:-left-3.25 data-[side=bottom]:rotate-0 data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180">
            <ArrowSvg />
          </BaseTooltip.Arrow>
          {children}
        </BaseTooltip.Popup>
      </BaseTooltip.Positioner>
    </BaseTooltip.Portal>
  );
}

export const Tooltip = {
  Provider: TooltipProvider,
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  Content: TooltipContent,
};
